var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('section',{staticClass:"content-box"},[_c('p',[_c('img',{attrs:{"src":"/img/logo.svg","width":"120"}})]),_c('h1',[_vm._v("Developer Portal")]),_c('div',{staticClass:"form-box"},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }